import { useProductFeatures } from 'bundles/custom-labels/features';
import { IdTypes } from 'bundles/product-features';

/**
 * Lightweight hook that only fetches product features for custom labels (enableCustomLabels).
 * Use this for prefetching in data providers so only the ProductFeatures query runs;
 * useCustomLabelsByCourseBranch uses this same hook and then runs CustomLabelsV2 and
 * WeekToModuleStatus when enableCustomLabels is true.
 * https://www.coursera.org/internal/feature-toggles?name=enableCustomLabels&namespace=globalCourseFeatures
 */
const useCustomLabelsFromProductFeatures = (courseId: string | undefined) => {
  const result = useProductFeatures({
    idType: IdTypes.Course,
    id: courseId || '',
    skip: !courseId,
    ssr: true,
  });

  // When in loading state, returns false
  const enableCustomLabels = result.features.get('globalCourseFeatures', 'enableCustomLabels');

  return {
    ...result,
    enableCustomLabels,
  };
};

export default useCustomLabelsFromProductFeatures;
